<template>
	<load
		v-if="loading"
		mode="table"
		class="mt-3"
		color="#f0f8ff"
		message="Carregando conversa"
		style="height: 98% !important"
	/>
	<div class="container-fluid px-0" v-else>
		<div class="row col-12">
			<div
				class="col-12 pt-2 d-flex justify-content-between align-items-center px-2"
				v-if="loadingConversation == false"
			>
				<h3 class="box-title mb-0 ml-2">
					<i class="mdi mdi-24px mdi-face-agent"></i>
					Suporte <b>SUAS</b>Fácil
				</h3>
				<h4
					class="mb-0 px-3"
					:class="support.status == 1 ? 'text-danger' : 'text-success'"
					v-if="mode == 'page' && support"
				>
					<Button
						class="btn btn-primary"
						v-if="support.status == 2"
						@click="$emit('novo')"
					>
						Novo Suporte
					</Button>
					{{ support.status == 1 ? "ABERTO" : support.status ? "RESOLVIDO" : "" }}
				</h4>
				<div class="box-tools pull-right mb-0" v-if="mode != 'page'">
					<button
						class="btn btn-box-tool btn-chat-fechar m-0 px-1 text-danger"
						v-on:click="
							$emit('minimizar');
							$emit('clear');
						"
					>
						<i class="fa fa-times"></i>
					</button>
				</div>
			</div>
		</div>
		<div
			:style="
				mode == 'page' ? 'height: calc(100vh - 190px)' : 'height: calc(100vh - 260px)'
			"
			style="background: aliceblue; overflow: hidden; padding-bottom: 20px"
			class="rounded col-12"
		>
			<Conversation
				:load="loadingConversation"
				:contact="selectedContact"
				:messages="messages"
				:sending="sending"
				:writemessage="writemessage"
				:writesupportname="write_support_name"
				box="suporte"
				:status="status"
				:support="support"
				@sending="sending = true"
				@completed="reloadPage"
				@new="onMessage"
				@writing="writingMessage(true)"
				@stop-writing="writingMessage(false)"
			/>
		</div>
	</div>
</template>

<script>
import Conversation from "./Conversation";
import UnreadComponent from "./UnreadComponent";
import { FlowerSpinner } from "epic-spinners";
import socket from "@/dashboard/socket";

export default {
	name: "BoxChatSupport",
	components: {
		Conversation,
		UnreadComponent,
		FlowerSpinner,
	},
	props: ["minimizar", "mode", "selected"],
	data() {
		return {
			loading: false,
			hasNewMessages: false,
			sending: false,
			selectedContact: null,
			support: null,
			messages: [],
			newmessage: "",
			loadingConversation: false,
			urlsound: `${window.location.protocol}//${window.location.host}sound/alert.mp3`,
			showContacts: false,
			writemessage: false,
			write_support_name: "",
			status: 1,
		};
	},

	created() {
		// let userID = this.$store.state.user.id;
		// let username = this.$store.state.user.name;
		// let path = this.$store.state.settings.path;
		// socket.auth = { userID, username };
		// socket.userID = userID;
		// socket.connect();

		// socket.emit(
		// 	"set user logado",
		// 	this.$store.state.user,
		// 	this.$store.state.settings.path
		// );

		socket.on("set private message", (content, name) => {
			// if (this.support.contact.tecnico_id == content.from) {
			if (content.from == "Gestao.Suporte") {
				axios
					.post("api/dashboard/support/conversation/send", {
						type: "send_support",
						text: content.text,
						support: name,
					})
					.then((response) => {
						this.messages.push(response.data);
						setTimeout(() => {
							document.getElementById("msn-support").scroll({
								top: document.getElementById("msn-support").scrollHeight,
								left: 0,
								behavior: "smooth",
							});
						}, 50);
					})
					.finally(() => {
						swal.fire({
							toast: true,
							position: "top-end",
							icon: "success",
							title: "Nova mensagem no canal de Suporte",
							showConfirmButton: false,
							timerProgressBar: true,
							timer: 3000,
						});
					});
			}

			// }
		});
		this.startConversation();
		socket.on("writing", (content, name) => {
			this.writemessage = true;
			this.write_support_name = name;
		});
		socket.on("stop writing", (content, name) => {
			this.writemessage = false;
			this.write_support_name = name;
		});
		socket.on("support close", (name) => {
			swal.fire({
				text: `O suporte foi finalizado por ${name}.`,
				icon: "warning",
				showConfirmButton: false,
				timer: 3000,
			});
			this.startConversation(this.selected);
		});
		socket.on("reload", (name) => {
			this.startConversation(this.selected, false);
		});
	},
	watch: {
		selected() {
			//console.log(this.selected);
			this.startConversation(this.selected);
		},
	},
	methods: {
		reloadPage() {
			this.startConversation(this.selected, false);
			let path = this.$store.state.settings.path;
			let user = this.$store.state.user;
			socket.emit(
				"private message support reload",
				path,
				user.id,
				user.name,
				"cliente"
			);
		},
		startConversation(selected = null, load = true) {
			this.loadingConversation = load;
			var id = selected != null ? selected : 0;

			this.sending = false;
			axios.get(`api/dashboard/support/conversation/${id}`).then((response) => {
				this.support = response.data;
				this.status = this.support ? this.support.status : 1;
				this.messages = response.data.messages;
				this.loadingConversation = false;
			});
		},
		beep() {
			var audio = document.getElementById("audio");
			if (audio) {
				let startPlayPromise = audio.play();

				if (startPlayPromise !== undefined) {
					startPlayPromise
						.then(() => {
							// Start whatever you need to do only after playback
							// has begun.
						})
						.catch((error) => {
							if (error.name === "NotAllowedError") {
								// showPlayButton(audio);
							} else {
								// Handle a load or playback error
							}
						});
				}
			}
		},
		onMessage(data) {
			let message = data.text;
			let path = this.$store.state.settings.path;
			data.to = "Suporte";

			this.sending = true;
			if (this.messages !== undefined) {
				this.messages.push(data);
			} else {
				this.messages = [
					{
						id: data.id,
						from: data.from,
						to: data.to,
						support_id: data.support_id,
						text: data.text,
						created_at: data.created_at,
					},
				];
			}

			socket.emit("private message support", data, path, "cliente");
			this.startConversation(null, false);
		},
		writingMessage(status) {
			let path = this.$store.state.settings.path;
			let user = this.$store.state.user;
			let destino = "Gestao.Suporte";
			socket.emit("writing", destino, user, path, status, "support");
		},
	},
};
</script>

<style lang="css" scoped>
.nav-link {
	cursor: pointer;
}
.list-group-item {
	position: relative;
	display: block;
	padding: 0.75rem 1.25rem;
	background-color: #fff;
	border: 0 !important;
	border-bottom: 1px solid #f4f4f4 !important;
	cursor: pointer;
	font-weight: bold;
	font-size: 14px;
	text-transform: uppercase;
}
.list-group-item:hover {
	background: #f4f4f4;
}

::-webkit-scrollbar-track {
	background-color: #f4f4f4;
}
::-webkit-scrollbar {
	width: 5px;
	background: #f4f4f4;
}
::-webkit-scrollbar-thumb {
	background: #979797;
	border-radius: 25em;
}

.morris-hover {
	position: absolute;
	z-index: 99 !important;
}
.new-btn-chat {
	display: flex;
	width: 45px;
	height: 45px;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	border: 0;
	background: #1f89e5;
	color: #fff;
	border-radius: 50%;
	transition: all 0.2s;
	-webkit-transform: scale(1);
	-moz-transform: scale(1);
	-o-transform: scale(1);
	transform: scale(1);
	border: 2px solid #fff;
}

.new-btn-chat:hover {
	background: #44a8ff;
	box-shadow: 0 20px 30px rgba(0, 0, 0, 0.3);
	-webkit-transform: scale(1.4);
	-moz-transform: scale(1.4);
	-o-transform: scale(1.4);
	transform: scale(1.4);
}

.btn-animated {
	animation: moveInBottom 5s ease-out;
	animation-fill-mode: backwards;
}
@keyframes moveInBottom {
	0% {
		opacity: 0;
		transform: scale(1.4);
	}

	100% {
		opacity: 1;
		transform: scale(0px);
	}
}

/* .btn-chat {
  font-size: 18px;
  color: #fff;
  background: #1f89e5;
  padding: 7.5px 10px 7.5px 10px;
  border-radius: 50%;
  box-shadow: 0 1px 4px 0px rgb(0 0 0 / 39%);
  cursor: pointer;
  z-index: 9999;
  min-height: 40px;
  max-height: 40px;
  height: 40px;
  overflow: hidden;
} */
/* .btn-chat:hover {
  background: #0d5a9e;
} */
.chat-app {
	display: flex;
}
.box-chat {
	position: fixed;
	z-index: 1001;
	bottom: 30px;
	right: 30px !important;
	display: block;
	width: 50%;
	height: calc(100% - 200px);
	overflow: hidden;
	border-radius: 2px;
	background: white;
	box-sizing: content-box;
	box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 15%) !important;
	max-width: 800px;
	padding: 1rem;
	overflow: auto;
}

@media (min-width: 767px) AND (max-width: 1200px) {
	.box-chat {
		position: fixed;
		z-index: 1001;
		bottom: 40px;
		right: 40px !important;
		display: block;
		width: 70% !important;
		height: 70vh;
		overflow: hidden !important;
		border-radius: 2px;
		background: white;
		box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 15%) !important;
		max-width: 800px;
		overflow: auto;
	}
}
@media (min-width: 567px) AND (max-width: 767px) {
	.box-chat {
		position: fixed;
		z-index: 9999;
		bottom: 60px;
		display: none;
		width: 90%;
	}
	.direct-chat-info {
		display: block;
		margin-bottom: 2px;
		font-size: 14px;
		width: 400px;
	}
}
@media (max-width: 567px) {
	.box-chat {
		position: fixed;
		z-index: 9999;
		bottom: 60px;
		display: none;
		width: 99%;
	}
	.direct-chat-info {
		display: block;
		margin-bottom: 2px;
		font-size: 14px;
		width: 300px;
	}
}
</style>
